import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/monument-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-monument-colorado",
      statusCode: 301,
    });
  },
});
